import { inject } from '@angular/core';
import { 
  ActivatedRouteSnapshot, 
  Router, 
  CanActivate,
  RedirectCommand,
  UrlTree
} from '@angular/router';
import { StreamService } from '../services/stream_service';
export class StreamIdGuard implements CanActivate {
  private router = inject(Router);
  private streamService = inject(StreamService);

  canActivate(route: ActivatedRouteSnapshot): Promise<boolean | RedirectCommand> {
    const homeUrl: UrlTree = this.router.parseUrl('/');

    if (route.params['custom-url']) {
      const customUrl = route.params['custom-url'];
      return this.streamService.getStreamIdFromCustomUrl(customUrl)
        .then(result => {
          const isValidId = !/[a-zA-Z]/.test(result.channel.id);
          
          if (isValidId) {
            return true;
          } else {
            return new RedirectCommand(homeUrl);
          }
        })
        .catch(err => {
          console.error('Error while fetching stream custom-url data', err);
          return new RedirectCommand(homeUrl);
        });
    } else {
      const streamId = route.params['id'];
      return this.streamService.getStreamInfo(streamId)
        .then(() => true)
        .catch(err => {
          console.error('Error while fetching stream', err);
          return new RedirectCommand(homeUrl);
        });
    }
  }
}
